import { useMatch } from 'react-router-dom';
import { useCurrentUserContext } from '@/contexts';
import { useIsMagic } from '@/hooks/useIsMagic';

type Ret = {
  tabIndex: number;
};

export const useTabIndex = (): Ret => {
  const { isAuthenticated } = useCurrentUserContext();
  const { isMagic, isMagicLandingPage } = useIsMagic();
  const isDashboard = useMatch('/dashboard') !== null;

  if (!isAuthenticated) {
    return { tabIndex: 1 };
  }

  let tabIndex = -1;
  if (isMagicLandingPage || isMagic) {
    tabIndex = 1;
  } else if (isDashboard) {
    tabIndex = 0;
  }

  return { tabIndex };
};
